module.exports = __webpack_public_path__ + "static/dashboard_screen-eded2d8866c5779ce19dbc1c0a238e9a.png";